module.exports = "/images/delete2.svg?31e2b2b25500fe1dea256e4521c1e7b0";